import { useEffect, useState, type MouseEvent, type ReactNode } from "react";

export function navigate(href: string) {
  window.history.pushState({}, "", href);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

export function usePath() {
  const [path, setPath] = useState(window.location.pathname);
  useEffect(() => {
    const update = () => setPath(window.location.pathname);
    window.addEventListener("popstate", update);
    return () => window.removeEventListener("popstate", update);
  }, []);
  return path;
}

export function Link({ href, className, children, title }: { href: string; className?: string; children: ReactNode; title?: string }) {
  const onClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || href.startsWith("http")) return;
    event.preventDefault();
    navigate(href);
  };
  return <a href={href} className={className} title={title} onClick={onClick}>{children}</a>;
}
